import { createSlice } from '@reduxjs/toolkit';

// Use stored preference, or default to light theme
const getInitialTheme = () => {
  const storedTheme = localStorage.getItem('themeMode');
  if (storedTheme) {
    return storedTheme; // User has a saved preference
  }
  return 'light'; // Default to light theme
};

const initialState = {
  mode: getInitialTheme() // 'light' or 'dark'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme(state) {
      state.mode = state.mode === 'dark' ? 'light' : 'dark';
      localStorage.setItem('themeMode', state.mode);
    },
    setTheme(state, action) {
      state.mode = action.payload.mode;
      localStorage.setItem('themeMode', state.mode);
    }
  }
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export const themeModeSelector = (state) => state.theme.mode;
export default themeSlice.reducer;
